<template>
	<main>
		<h1>CV</h1>

		<div class="row">
			<div class="fact">Position</div>
			<div class="description">
				Front-end developer (remote only)
			</div>
		</div>
		<div class="row">
			<div class="fact">Birth date</div>
			<div class="description">
				25/07/1999
			</div>
		</div>
		<div class="row">
			<div class="fact">Skills</div>
			<div class="description">
				<p>I am specializing in front-end mostly.</p>
				<p>
					<b>Front-end</b><br />
					JavaScript (ES6+), jQuery, TypeScript<br />
					Vue.js, Vuex, Nuxt.js<br />
					Reactjs, Redux<br />
					Pug (jade)<br />
					Sass (Scss), Less
				</p>
				<p>
					<b>Back-end</b><br />
					Node.js, Express<br />
					Mongoose, MongoDB, Firebase<br />
					WebSocket / Socket.io
				</p>
				<p>
					<b>Services</b><br />
					Git, Gulp, Webpack, GraphQL (Apollo)
				</p>
			</div>
		</div>
		<div class="row">
			<div class="fact">Portfolio</div>
			<div class="description">
				<div class="block" v-for="(item, i) of cases" :key="i">
					<h3>
						{{ item.title }}
						<a :href="item.link" target="_blank">{{ item.link }}</a> ({{
							item.date
						}})
					</h3>
					<p>{{ item.text }}</p>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="fact">About me</div>
			<div class="description">
				I started learn web development and web design in March 2017. I was
				creating landings and simple web pages with libraries like jQuery. Since
				2018 I am creating single page applications using Vue.js or React.js.
			</div>
		</div>
		<div class="row">
			<div class="fact">Address</div>
			<div class="description">
				Togliatti, Russia
			</div>
		</div>
		<div class="row">
			<div class="fact">Contacts</div>
			<div class="description">
				<contacts />
			</div>
		</div>

		<footer>Last update: Jun 2021</footer>
	</main>
</template>

<script>
import Contacts from "@/components/Contacts";

export default {
	name: "CV",
	mounted() {
		document.title = "Sunpacker's curriculum vitae";
		document.getElementsByTagName("html")[0].style.backgroundColor = "#302D2D";
	},
	destroyed() {
		document.getElementsByTagName("html")[0].removeAttribute("style");
	},
	computed: {
		cases() {
			return this.$store.state.cases;
		}
	},
	components: {
		Contacts
	}
};
</script>

<style lang="sass" scoped>
@import '@/assets/css/smart-grid'
@import '@/assets/css/_vars'

$font1: -apple-system, Arial, system-ui, sans-serif
$font2: 'Times New Roman', serif

h1
	font: 1.75rem $font2
h3
	font-weight: bold
p
	margin-bottom: 1rem
	line-height: 1.5rem
a
	text-decoration: none
	color: $c2
	&:active
		color: $c1
	&:visited
		color: $c2

main
	+wrapper()
	margin: 1rem auto
	padding: 2rem 4rem
	font-family: $font1
	border-radius: .25rem
	background-color: #fff
	box-sizing: border-box
	h1
		margin: 1.5rem 0
		font-weight: bold
		border-bottom: .15rem solid $c1
	.row
		display: flex
		flex-wrap: wrap
		margin-bottom: 1.5rem
		.fact
			+size(3)
			+size-xs(12)
			margin-bottom: .5rem
		.description
			+size(9)
			+size-xs(12)
		.block
			h3
				display: block
				margin-bottom: .5rem
		.col
			+size(3)
			display: inline-flex
			justify-content: center
			align-items: center
			img
				display: block
				max-width: 1.25rem
				height: auto
				margin-right: .5rem
			a
				display: block
	footer
		margin-top: 3rem
		text-align: right
</style>
